module.exports = __webpack_public_path__ + "static/image/audience-none-words.svg?2dc7ff1e5b4f787fdb3c3cec5a95c3af";